import script from "./HomepageBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./HomepageBeplanet.vue?vue&type=style&index=0&id=a66a5514&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a66a5514"]])

export default __exports__